import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import HigherEducationDetails from '../../subdepartmentdetails/HigherEducationGTSU'

function HigherEducation() {
  useEffect(() => {
    document.getElementById('title').innerHTML = 'GTS State University || Education'
  }, [])

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom
          // subtitle="Education Youth Services"
          // title="Higher Education - GTS State University (GTSU)"
          subtitledown="GTS State University"
        />
        <HigherEducationDetails />
      </div>
    </>
  )
}

export default HigherEducation
